import Lenis from '@studio-freight/lenis';

declare global {
  interface Window {
    LENIS: Lenis;
  }
}

const lenis = (): void => {
  window.LENIS = new Lenis();
  const raf = (time: DOMHighResTimeStamp): void => {
    window.LENIS.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
};

export default lenis;
